import { createConsumer } from "@rails/actioncable";
import { createGuestChannel } from "channels/guest_channel";

window.App || (window.App = {});

function initializeCreateConsumer() {
  window.App.cable = createConsumer();
  createGuestChannel({ cable: window.App.cable });
}

document.removeEventListener("DOMContentLoaded", initializeCreateConsumer);
document.addEventListener("DOMContentLoaded", initializeCreateConsumer);
